export class NonCommissionType {

  static readonly PAID_DIRECT = 'Commission Paid Direct';
  static readonly EVENT_CANCELLED = 'Event Cancelled';

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/non-commission-type.ts